"use strict";
exports.__esModule = true;
exports.timelineDataFr = void 0;
var dateutil_1 = require("./dateutil");
exports.timelineDataFr = [
    {
        label: "Chaîne Youtube Timmy O'Toole synthés",
        startDate: (0, dateutil_1.toTs)("2017-01-01"),
        endDate: (0, dateutil_1.toTs)("2021-01-01"),
        type: "YOUTUBE",
        line: 0,
        description: "J'ai créé une chaîne Youtube sur les synthétiseurs. J'y partageais des astuces pour créer des sons.<br/><br/><a target='_blank' href='https://www.youtube.com/timmyotoole5'>Youtube</a>",
        place: "Bruxelles",
        country: "Belgique",
        flagFilename: "belgium"
    },
    {
        label: "Monstres B Prod",
        startDate: (0, dateutil_1.toTs)("2018-01-01"),
        endDate: (0, dateutil_1.toTs)("2023-01-01"),
        type: "FILM_PROD",
        line: 1,
        description: "On a commencé par écrire, réaliser et produire des <a target='_blank' href='https://www.youtube.com/watch?v=0gTdkHNUlR8&list=PL2jG_yWKkayQKmEnf-MDymj8qRGTyRNPZ'>films de monstres</a> avec des amis. Mais avec le temps, on s'est tournés vers des expériences plus réalistes :<br><ul><li><a target='_blank' href='https://www.youtube.com/playlist?list=PL2jG_yWKkaySWm0SUfcDY7ftFcA2pNSma'>Traverser la Belgique en ligne droite</a></li><li><a target='_blank' href='https://www.instagram.com/p/Cdo4RngDnzL/'>Créer une religion autour du film Sauvez Willy</a></li><li><a target='_blank' href='https://www.youtube.com/watch?v=c09N7Rf9RPI'>Spectro+ : énergie gratuite de l'au-delà</a></li></ul><br/>J'ai composé la musique sur tous ces projets.<br/><br/><a target='_blank' href='https://www.monstresbprod.be'>Site web</a><br/><a target='_blank' href='https://www.youtube.com/@monstresbprod4591'>Youtube</a>",
        place: "Bruxelles",
        country: "Belgique",
        flagFilename: "belgium"
    },
    {
        label: "OneLittleSynthesizer",
        startDate: (0, dateutil_1.toTs)("2018-10-01"),
        endDate: (0, dateutil_1.toTs)("2020-01-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "J'ai créé mon propre plugin de synthétiseur en C++ avec JUCE. <br/><a target='_blank' href='https://github.com/GuillaumeElias/OneLittleSynthesizer'>Github</a>"
    },
    {
        label: "Midi to Text animator",
        startDate: (0, dateutil_1.toTs)("2020-02-01"),
        endDate: (0, dateutil_1.toTs)("2020-05-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "J'ai créé un plugin qui affiche du texte à partir d'événements MIDI.<br/><a target='_blank' href='https://github.com/GuillaumeElias/MidiNoteToTextAnimator'>Github</a>"
    },
    {
        label: "Nutekt-MOSC",
        startDate: (0, dateutil_1.toTs)("2020-07-01"),
        endDate: (0, dateutil_1.toTs)("2020-09-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "J'ai créé un oscillateur personnalisé pour le Korg Nutekt NTS-1.<br/><a target='_blank' href='https://github.com/GuillaumeElias/Nutekt-MOSC'>Github</a>"
    },
    {
        label: "Rue des glands",
        startDate: (0, dateutil_1.toTs)("2021-02-01"),
        endDate: (0, dateutil_1.toTs)("2021-05-01"),
        type: "FILM_WORK",
        line: 0,
        description: "J'ai joué en tant qu'acteur dans un court métrage intitulé 'Rue des Glands'. <br/> <br/> Réalisé par Étienne Bloc & Audrey Guibert.<br/><br/> <a target='_blank' href='https://legenerique.be/film/30'>Plus d'infos ici</a> <br/> <br/> Team Tchin Prod",
        place: "Bruxelles",
        country: "Belgique",
        flagFilename: "belgium"
    },
    {
        label: "Alien Kermesse",
        startDate: (0, dateutil_1.toTs)("2021-07-01"),
        endDate: (0, dateutil_1.toTs)("2021-10-01"),
        type: "FILM_WORK",
        line: 0,
        description: "J'ai joué en tant qu'acteur dans une série TV appelée Alien Kermesse financée par la RTBF.<br/><br/><a target='_blank' href='https://rtbfcreative.be/programme/-1715854888'>Voir ici</a> <br/> <br/> Réalisée par Maxime Dambly & Manon Henry. <br/> <br/> Produit par <a target='_blank' href='https://www.bigtrouble.be/'>Big Trouble Production</a>",
        place: "Bruxelles",
        country: "Belgique",
        flagFilename: "belgium"
    },
    {
        label: "Développé Couché",
        startDate: (0, dateutil_1.toTs)("2022-03-01"),
        endDate: (0, dateutil_1.toTs)("2022-06-01"),
        type: "FILM_WORK",
        line: 0,
        description: "J'ai été acteur et compositeur sur un court-métrage réalisé par Audrey Guibert.<br/><br/><a target='_blank' href='https://legenerique.be/film/29'>Plus d'infos ici</a>",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "No Exceptions",
        startDate: (0, dateutil_1.toTs)("2024-10-01"),
        endDate: (0, dateutil_1.toTs)("2024-12-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "J'ai travaillé comme preneur de son sur un court métrage intitulé <a target='_blank' href='https://www.instagram.com/p/DGn6d23JfpH/'>No Exceptions</a> <br/> <br/> Réalisé par Nathan George et produit par Charlie Osler<br/> <br/> Produit par <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "All About Mia",
        startDate: (0, dateutil_1.toTs)("2025-01-01"),
        endDate: (0, dateutil_1.toTs)("2025-03-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "J'ai travaillé comme preneur de son sur un court métrage intitulé All About Mia <br/> <br/> Réalisé et produit par Charlie Osler<br/> <br/> Produit par <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "The End",
        startDate: (0, dateutil_1.toTs)("2025-02-01"),
        endDate: (0, dateutil_1.toTs)("2025-04-01"),
        type: "SOUND_PROD",
        line: 2,
        description: "J'ai travaillé comme preneur de son rémunéré sur un court métrage intitulé The End, réalisé par Olivia Berkowitz et Molly Cole, produit par Emilia Michalowska.",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "Stand-up",
        startDate: (0, dateutil_1.toTs)("2021-01-01"),
        endDate: (0, dateutil_1.toTs)("2024-06-01"),
        type: "COMEDIAN",
        line: 2,
        description: "J'ai joué régulièrement en tant qu'humoriste dans plusieurs pays, dans des clubs comme : <ul><li>Le Terminal, Montréal</li><li>Le Bordel, Montréal</li><li>Yuk Yuk's, Toronto</li><li>Absolute Comedy, Toronto</li><li>Roes Comedy Club, Gand</li><li>Kings of Comedy, Bruxelles</li><li>RITCS, Bruxelles</li></ul><br/>Vous pouvez voir des extraits de mes performances <a target='_blank' href='https://www.instagram.com/timmy_o_toole/'>ici</a>."
    },
    {
        label: "FRENCHY",
        startDate: (0, dateutil_1.toTs)("2023-12-01"),
        endDate: (0, dateutil_1.toTs)("2025-04-01"),
        type: "FILM_PROD",
        line: 1,
        description: "J'écris, réalise et produis un pilote de série intitulé Frenchy avec Aidan Wright, directeur de la photographie. <br/><br/> <a target='_blank' href='https://frenchy.timmyotoole.art?password=notfrench' >Regarder ici</a> <br/> <br/> Produit par <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "Acceptance",
        startDate: (0, dateutil_1.toTs)("2025-05-01"),
        endDate: (0, dateutil_1.toTs)("2025-07-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "J'ai travaillé comme preneur de son rémunéré sur le tournage d' \"Acceptance\", un court métrage réalisé par Imane Hajouji.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "Capoté ben Raide",
        startDate: (0, dateutil_1.toTs)("2025-09-01"),
        endDate: (0, dateutil_1.toTs)("2025-12-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "J'ai travaillé comme preneur de son sur le tournage de \"Capoté ben Raide\", un court métrage réalisé par Dougy Hérard.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "The Beast We Hunt",
        startDate: (0, dateutil_1.toTs)("2026-02-01"),
        endDate: (0, dateutil_1.toTs)("2026-05-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "J'ai travaillé comme preneur de son sur le tournage de \"The Beast We Hunt\", un court métrage fantasy entièrement tourné en studio, réalisé par Arthur Beauchet.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "Fiasco",
        startDate: (0, dateutil_1.toTs)("2026-03-15"),
        endDate: (0, dateutil_1.toTs)("2026-06-01"),
        type: "SOUND_PROD",
        line: 2,
        description: "J'ai travaillé comme preneur de son sur le tournage de \"Fiasco\", un court métrage réalisé par Adrien Lessard",
        place: "St-Hyacinthe",
        country: "Canada"
    },
];
